/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type standaloneCreateInvoiceModalV2_viewer$ref = any;
export type standaloneCreateInvoiceModalV2_QueryVariables = {|
  startYear: number,
  startMonth: number,
  startDay: number,
  endYear: number,
  endMonth: number,
  endDay: number,
  isProjectInvoicing: boolean,
  projectId?: ?string,
|};
export type standaloneCreateInvoiceModalV2_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: standaloneCreateInvoiceModalV2_viewer$ref,
  |}
|};
export type standaloneCreateInvoiceModalV2_Query = {|
  variables: standaloneCreateInvoiceModalV2_QueryVariables,
  response: standaloneCreateInvoiceModalV2_QueryResponse,
|};
*/


/*
query standaloneCreateInvoiceModalV2_Query(
  $startYear: Int!
  $startMonth: Int!
  $startDay: Int!
  $endYear: Int!
  $endMonth: Int!
  $endDay: Int!
  $isProjectInvoicing: Boolean!
  $projectId: ID
) {
  viewer {
    actualPersonId
    component(name: "create_invoice_modal_standalone_v2")
    ...standaloneCreateInvoiceModalV2_viewer_480Tkq
    id
  }
}

fragment DeprecatedProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment PersonDropdown_persons on PersonTypeEdge {
  node {
    id
    fullName
    firstName
    lastName
    profilePictureId
    active
    client {
      id
    }
    role {
      name
      id
    }
  }
}

fragment ProjectDropdown_projects on ProjectTypeEdge {
  node {
    id
    name
    projectColor
    companyProjectId
    customProjectId
    status
    ...DeprecatedProjectIndicatorJS_project
    manualProgressOnProjectEnabled
    manualProgressOnPhasesEnabled
    manualProgressOnTasksEnabled
  }
}

fragment standaloneCreateInvoiceModalV2_viewer_480Tkq on Viewer {
  id
  backendId
  firstName
  actualPersonId
  availableFeatureFlags {
    key
    id
  }
  company {
    currency
    invoiceLastSequence
    invoiceQuantityDecimals
    exchangeRates {
      edges {
        node {
          id
          currency
          rate
        }
      }
    }
    modules {
      moduleType
      id
    }
    clients {
      edges {
        node {
          id
          name
        }
      }
    }
    allPersons(first: 1000000, onlyActive: false, excludeClientUsers: false) {
      edges {
        ...PersonDropdown_persons
        node {
          id
          firstName
          lastName
          profilePictureId
          profilePictureDefaultId
          role {
            id
            name
          }
        }
      }
    }
    id
  }
  project(internalId: $projectId) @include(if: $isProjectInvoicing) {
    id
    name
    projectColor
    isInProjectGroup
    companyProjectId
    projectGroupId
    currencyExchangeRate
    budgetType
    defaultPeriodBudgetType
    status
    budget
    projectEndYear
    projectEndMonth
    projectEndDay
    fullAccessToProject
    rateCard {
      id
      name
      currency
      parentRateCardId
      defaultRate
      rates(first: 10000) {
        edges {
          node {
            id
            rate
            startDate
            defaultRate
            role {
              id
              name
            }
          }
        }
      }
    }
    client {
      id
      name
    }
    invoiceTotals {
      invoiceId
      createdDay
      createdMonth
      createdYear
      invoicedWithoutTax
      invoicedWithoutTaxBaseCurrency
      invoicedWithoutTaxProjectCurrency
    }
    unInvoicedTotal(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {
      unInvoicedMinutes
      unInvoicedPrice
    }
    expenseItems {
      edges {
        node {
          id
          name
          approved
          expenseYear
          expenseMonth
          expenseDay
          billable
          partOfFixedPrice
          price
          cost
          quantity
          planned
          createdAt
          invoiceId
          invoiced
          person {
            id
            fullName
            profilePictureId
            profilePictureDefaultId
          }
          phase {
            id
            name
          }
        }
      }
    }
    retainerPeriods(first: 100000) {
      edges {
        node {
          id
          name
          periodBudgetType
          startYear
          startMonth
          startDay
          endYear
          endMonth
          endDay
          periodPriceAmount
          periodHoursAmount
          periodLocked
          invoiced
          sharedPeriodDifferencePriceAmount
        }
      }
    }
    ...DeprecatedProjectIndicatorJS_project
  }
  projects(excludeDoneOrHalted: true) @skip(if: $isProjectInvoicing) {
    edges {
      ...ProjectDropdown_projects
      node {
        id
        name
        projectColor
        isInProjectGroup
        companyProjectId
        projectGroupId
        currencyExchangeRate
        budgetType
        defaultPeriodBudgetType
        status
        budget
        projectEndYear
        projectEndMonth
        projectEndDay
        fullAccessToProject
        invoiceTotals {
          invoiceId
          createdDay
          createdMonth
          createdYear
          invoicedWithoutTax
          invoicedWithoutTaxBaseCurrency
          invoicedWithoutTaxProjectCurrency
        }
        unInvoicedTotal(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {
          unInvoicedMinutes
          unInvoicedPrice
        }
        currentProjectStatus {
          id
          color
        }
        client {
          id
          name
          logoId
          logoDefaultId
        }
        rateCard {
          id
          name
          currency
          parentRateCardId
          defaultRate
          rates(first: 10000) {
            edges {
              node {
                id
                rate
                startDate
                defaultRate
                role {
                  id
                  name
                }
              }
            }
          }
        }
        expenseItems {
          edges {
            node {
              id
              name
              approved
              expenseYear
              expenseMonth
              expenseDay
              billable
              partOfFixedPrice
              price
              cost
              quantity
              planned
              createdAt
              invoiceId
              invoiced
              person {
                id
                fullName
                profilePictureId
                profilePictureDefaultId
              }
              phase {
                id
                name
              }
            }
          }
        }
        retainerPeriods(first: 100000) {
          edges {
            node {
              id
              name
              periodBudgetType
              startYear
              startMonth
              startDay
              endYear
              endMonth
              endDay
              periodPriceAmount
              periodHoursAmount
              periodLocked
              invoiced
              sharedPeriodDifferencePriceAmount
            }
          }
        }
        ...DeprecatedProjectIndicatorJS_project
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isProjectInvoicing",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "create_invoice_modal_standalone_v2"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"create_invoice_modal_standalone_v2\")"
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v7 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v8 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = [
  (v9/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyExchangeRate",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultPeriodBudgetType",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v13/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentRateCardId",
      "storageKey": null
    },
    (v31/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "RateTypeConnection",
      "kind": "LinkedField",
      "name": "rates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RateTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Rate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v12/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startDate",
                  "storageKey": null
                },
                (v31/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "role",
                  "plural": false,
                  "selections": (v14/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "rates(first:10000)"
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectInvoiceTotalType",
  "kind": "LinkedField",
  "name": "invoiceTotals",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoicedWithoutTax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoicedWithoutTaxBaseCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoicedWithoutTaxProjectCurrency",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "concreteType": "UnInvoicedProjectTotal",
  "kind": "LinkedField",
  "name": "unInvoicedTotal",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unInvoicedMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unInvoicedPrice",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseItemTypeConnection",
  "kind": "LinkedField",
  "name": "expenseItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExpenseItemTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "approved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expenseYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expenseMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expenseDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "partOfFixedPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "price",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planned",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            (v33/*: any*/),
            (v36/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v15/*: any*/),
                (v16/*: any*/),
                (v17/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseType",
              "kind": "LinkedField",
              "name": "phase",
              "plural": false,
              "selections": (v14/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100000
    }
  ],
  "concreteType": "RetainerPeriodTypeConnection",
  "kind": "LinkedField",
  "name": "retainerPeriods",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetainerPeriodTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RetainerPeriodType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodBudgetType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodPriceAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodHoursAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodLocked",
              "storageKey": null
            },
            (v36/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sharedPeriodDifferencePriceAmount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "retainerPeriods(first:100000)"
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "standaloneCreateInvoiceModalV2_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "isProjectInvoicing",
                "variableName": "isProjectInvoicing"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "standaloneCreateInvoiceModalV2_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "standaloneCreateInvoiceModalV2_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backendId",
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceLastSequence",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceQuantityDecimals",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ExchangeRateTypeConnection",
                "kind": "LinkedField",
                "name": "exchangeRates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExchangeRateTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExchangeRate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientTypeConnection",
                "kind": "LinkedField",
                "name": "clients",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "excludeClientUsers",
                    "value": false
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                  },
                  {
                    "kind": "Literal",
                    "name": "onlyActive",
                    "value": false
                  }
                ],
                "concreteType": "PersonTypeConnection",
                "kind": "LinkedField",
                "name": "allPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v15/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Client",
                            "kind": "LinkedField",
                            "name": "client",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "allPersons(excludeClientUsers:false,first:1000000,onlyActive:false)"
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "isProjectInvoicing",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "internalId",
                    "variableName": "projectId"
                  }
                ],
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v13/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Client",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isProjectInvoicing",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "excludeDoneOrHalted",
                    "value": true
                  }
                ],
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v13/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v39/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualProgressOnProjectEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualProgressOnPhasesEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualProgressOnTasksEnabled",
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectStatus",
                            "kind": "LinkedField",
                            "name": "currentProjectStatus",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Client",
                            "kind": "LinkedField",
                            "name": "client",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "logoId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "logoDefaultId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v32/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(excludeDoneOrHalted:true)"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "standaloneCreateInvoiceModalV2_Query",
    "operationKind": "query",
    "text": "query standaloneCreateInvoiceModalV2_Query(\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $isProjectInvoicing: Boolean!\n  $projectId: ID\n) {\n  viewer {\n    actualPersonId\n    component(name: \"create_invoice_modal_standalone_v2\")\n    ...standaloneCreateInvoiceModalV2_viewer_480Tkq\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment PersonDropdown_persons on PersonTypeEdge {\n  node {\n    id\n    fullName\n    firstName\n    lastName\n    profilePictureId\n    active\n    client {\n      id\n    }\n    role {\n      name\n      id\n    }\n  }\n}\n\nfragment ProjectDropdown_projects on ProjectTypeEdge {\n  node {\n    id\n    name\n    projectColor\n    companyProjectId\n    customProjectId\n    status\n    ...DeprecatedProjectIndicatorJS_project\n    manualProgressOnProjectEnabled\n    manualProgressOnPhasesEnabled\n    manualProgressOnTasksEnabled\n  }\n}\n\nfragment standaloneCreateInvoiceModalV2_viewer_480Tkq on Viewer {\n  id\n  backendId\n  firstName\n  actualPersonId\n  availableFeatureFlags {\n    key\n    id\n  }\n  company {\n    currency\n    invoiceLastSequence\n    invoiceQuantityDecimals\n    exchangeRates {\n      edges {\n        node {\n          id\n          currency\n          rate\n        }\n      }\n    }\n    modules {\n      moduleType\n      id\n    }\n    clients {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    allPersons(first: 1000000, onlyActive: false, excludeClientUsers: false) {\n      edges {\n        ...PersonDropdown_persons\n        node {\n          id\n          firstName\n          lastName\n          profilePictureId\n          profilePictureDefaultId\n          role {\n            id\n            name\n          }\n        }\n      }\n    }\n    id\n  }\n  project(internalId: $projectId) @include(if: $isProjectInvoicing) {\n    id\n    name\n    projectColor\n    isInProjectGroup\n    companyProjectId\n    projectGroupId\n    currencyExchangeRate\n    budgetType\n    defaultPeriodBudgetType\n    status\n    budget\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    fullAccessToProject\n    rateCard {\n      id\n      name\n      currency\n      parentRateCardId\n      defaultRate\n      rates(first: 10000) {\n        edges {\n          node {\n            id\n            rate\n            startDate\n            defaultRate\n            role {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n    client {\n      id\n      name\n    }\n    invoiceTotals {\n      invoiceId\n      createdDay\n      createdMonth\n      createdYear\n      invoicedWithoutTax\n      invoicedWithoutTaxBaseCurrency\n      invoicedWithoutTaxProjectCurrency\n    }\n    unInvoicedTotal(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {\n      unInvoicedMinutes\n      unInvoicedPrice\n    }\n    expenseItems {\n      edges {\n        node {\n          id\n          name\n          approved\n          expenseYear\n          expenseMonth\n          expenseDay\n          billable\n          partOfFixedPrice\n          price\n          cost\n          quantity\n          planned\n          createdAt\n          invoiceId\n          invoiced\n          person {\n            id\n            fullName\n            profilePictureId\n            profilePictureDefaultId\n          }\n          phase {\n            id\n            name\n          }\n        }\n      }\n    }\n    retainerPeriods(first: 100000) {\n      edges {\n        node {\n          id\n          name\n          periodBudgetType\n          startYear\n          startMonth\n          startDay\n          endYear\n          endMonth\n          endDay\n          periodPriceAmount\n          periodHoursAmount\n          periodLocked\n          invoiced\n          sharedPeriodDifferencePriceAmount\n        }\n      }\n    }\n    ...DeprecatedProjectIndicatorJS_project\n  }\n  projects(excludeDoneOrHalted: true) @skip(if: $isProjectInvoicing) {\n    edges {\n      ...ProjectDropdown_projects\n      node {\n        id\n        name\n        projectColor\n        isInProjectGroup\n        companyProjectId\n        projectGroupId\n        currencyExchangeRate\n        budgetType\n        defaultPeriodBudgetType\n        status\n        budget\n        projectEndYear\n        projectEndMonth\n        projectEndDay\n        fullAccessToProject\n        invoiceTotals {\n          invoiceId\n          createdDay\n          createdMonth\n          createdYear\n          invoicedWithoutTax\n          invoicedWithoutTaxBaseCurrency\n          invoicedWithoutTaxProjectCurrency\n        }\n        unInvoicedTotal(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {\n          unInvoicedMinutes\n          unInvoicedPrice\n        }\n        currentProjectStatus {\n          id\n          color\n        }\n        client {\n          id\n          name\n          logoId\n          logoDefaultId\n        }\n        rateCard {\n          id\n          name\n          currency\n          parentRateCardId\n          defaultRate\n          rates(first: 10000) {\n            edges {\n              node {\n                id\n                rate\n                startDate\n                defaultRate\n                role {\n                  id\n                  name\n                }\n              }\n            }\n          }\n        }\n        expenseItems {\n          edges {\n            node {\n              id\n              name\n              approved\n              expenseYear\n              expenseMonth\n              expenseDay\n              billable\n              partOfFixedPrice\n              price\n              cost\n              quantity\n              planned\n              createdAt\n              invoiceId\n              invoiced\n              person {\n                id\n                fullName\n                profilePictureId\n                profilePictureDefaultId\n              }\n              phase {\n                id\n                name\n              }\n            }\n          }\n        }\n        retainerPeriods(first: 100000) {\n          edges {\n            node {\n              id\n              name\n              periodBudgetType\n              startYear\n              startMonth\n              startDay\n              endYear\n              endMonth\n              endDay\n              periodPriceAmount\n              periodHoursAmount\n              periodLocked\n              invoiced\n              sharedPeriodDifferencePriceAmount\n            }\n          }\n        }\n        ...DeprecatedProjectIndicatorJS_project\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd21dd3f260b7941906d505fff93c0257';

module.exports = node;
